import { Key } from "react";
import { Table } from "@/components/v2";

interface CompanyServicePartnersTable {
  servicePartners?: {
    fullName: string | null;
    value: string | null;
  }[];
  value?: Key[];
  onChange?: (selectedRowKeys: Key[]) => void;
  editable?: boolean;
}

export const CompanyServicePartnersTable = ({
  servicePartners,
  value,
  onChange,
  editable = false,
}: CompanyServicePartnersTable) => {
  const servicePartnerColumns = [
    {
      title: "Hersteller",
      dataIndex: "fullName",
      key: "fullName",
    },
  ];
  return (
    <Table
      dataSource={servicePartners ?? []}
      columns={servicePartnerColumns}
      rowKey="value"
      pagination={false}
      rowSelection={
        editable
          ? {
              type: "checkbox",
              selectedRowKeys: value,
              onChange: onChange,
            }
          : undefined
      }
      size="small"
    />
  );
};
